import { NOTIFICATION_INFINITE_DURATION, NOTIFICATION_LONG_DURATION, NOTIFICATION_MEDIUM_DURATION, NotificationAlert, NotificationAlertType } from "@/js/interfaces/Components/alpinejs/NotificationAlert";
import { dispatch, translate } from "./utils";

/**
 * Notify the user with an alert message
 */
export function notifyAlert(
    title: NotificationAlert["title"],
    message: NotificationAlert["message"],
    type: NotificationAlertType,
    duration: NotificationAlert["duration"],
    onClose: NotificationAlert["onClose"] = null,
) {
    dispatch('notify-alert', {
        title,
        message,
        type,
        duration,
        onClose,
    });
}

/**
 * Notify the user with an alert for a successfull action.
 */
export function notifySuccessAlert(
    message: NotificationAlert["message"],
    duration: NotificationAlert["duration"] = NOTIFICATION_MEDIUM_DURATION,
    title: NotificationAlert["title"] = translate("Successfull action"),
) {
    notifyAlert(
        title,
        message,
        "success",
        duration,
    );
}

/**
 * Notify the user with an alert for a successfull action.
 */
export function notifyInformationAlert(
    message: NotificationAlert["message"],
    duration: NotificationAlert["duration"] = NOTIFICATION_LONG_DURATION,
    title: NotificationAlert["title"] = translate("Information"),
) {
    notifyAlert(
        title,
        message,
        "info",
        duration,
    );
}

/**
 * Notify the user with an alert for an errorfull action.
 */
export function notifyErrorAlert(
    message: NotificationAlert["message"],
    duration: NotificationAlert["duration"] = NOTIFICATION_INFINITE_DURATION,
    title: NotificationAlert["title"] = translate("Errorfull action"),
) {
    notifyAlert(
        title,
        message,
        "danger",
        duration,
    );
}

/**
 * Notify the user with a banner message
 */
export function notifyBanner(
    message: NotificationAlert["message"],
    type: NotificationAlertType,
    onClose: NotificationAlert["onClose"] = null,
) {
    dispatch('notify-banner', {
        message,
        type,
        onClose,
    });
}
